// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4558":"304d4e64b4a0c45f","9625":"a2d254afc86f3501"}[chunkId] + ".css";
};